import React from "react";
import { useTranslation } from "react-i18next";
import { InfoPlate } from "fe-shared/src/components";
import { QueryKey } from "react-query";

import { Invoice } from "fe-shared-transactions/src/types";
import { formatInvoiceNumber } from "fe-shared-transactions/src/helpers/format";
import AssigneeInvoiceSelect from "../AssigneeInvoiceSelect";
import InvoiceStatusPlate from "../InvoiceStatusPlate";

import styles from "./InvoiceStatus.module.scss";

interface Props {
  invoice: Invoice;
  canAssign: boolean;
  invoiceQueryKey: QueryKey;
  activitiesQueryKey: QueryKey;
}

const InvoiceStatus = ({ invoice, ...otherProps }: Props) => {
  const { t } = useTranslation();
  const { statusCode, invoiceNumber, assignee } = invoice;
  const isAssigned = !!assignee?.userId;
  const isPostedToGP = invoice.isPostedToGP;

  return (
    <div className={styles.header}>
      <div className={styles.status}>
        <InfoPlate variant="dark" className={styles.statusInfoPlate}>
          {formatInvoiceNumber(invoiceNumber)}
        </InfoPlate>
        <InvoiceStatusPlate
          statusCode={statusCode}
          className={styles.statusInfoPlate}
        />
        <div className={styles.statusAssign}>
          {isAssigned && (
            <span className={styles.statusAssignLabel}>
              {t("transactions.details.assignedTo")}
            </span>
          )}
          <AssigneeInvoiceSelect
            invoice={invoice}
            isPostedToGP={!!isPostedToGP}
            assigneeId={assignee?.userId}
            assigneeName={assignee?.displayName ?? undefined}
            {...otherProps}
          />
        </div>
      </div>
    </div>
  );
};

export default InvoiceStatus;
